import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import logoLight from "../../assets/images/logoLight.svg";
import { getMainSiteUrl } from "../../constants/appConfig";
import { SITE } from "../../constants/site";
import { getFeaturedImageUrl, stripHtml } from "../../services/wpPagesApi";
import { buildAbsoluteUrl } from "../../utils/seo";
import "./LandingHeader.css";

function LandingHeader() {
  const { t } = useTranslation();

  return (
    <header className="landing-header">
      <div className="landing-header__inner">
        <a href={getMainSiteUrl()} className="landing-header__brand" aria-label={SITE.name}>
          <img src={logoLight} alt={SITE.name} className="landing-header__logo" />
        </a>
        <div className="landing-header__actions">
          <a href={getMainSiteUrl()} className="landing-header__cta">
            {t("Visit Main Site")}
          </a>
        </div>
      </div>
    </header>
  );
}

export default LandingHeader;

export function LandingSeo({ page }) {
  if (!page) {
    return null;
  }

  const title = stripHtml(page.title?.rendered || SITE.name);
  const description =
    stripHtml(page.excerpt?.rendered || page.content?.rendered || "").slice(
      0,
      160,
    ) || SITE.name;
  const image = getFeaturedImageUrl(page) || buildAbsoluteUrl("/logoDark.svg");
  const canonicalUrl = buildAbsoluteUrl("/");

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
